// @flow
import { createAction } from 'redux-actions';

import type { ActionType } from 'types/redux';

export const SET_THEME = 'ui/theme/SET_THEME';
const setTheme = createAction(SET_THEME);

const actions = {
  setTheme
};
export default actions;

export type Action = ActionType<$Values<typeof actions>>;



// WEBPACK FOOTER //
// ./src/store/reducers/ui/theme/actions.js